export default function CowLoader({ text = 'Cargando...' }) {
  return (
    <div className="cow-loader-wrapper">
      <div className="cow-loader-card">
        <div className="cow-orbit">
          <div className="cow-face">🐮</div>
          <div className="orbit-ring" />
          <div className="orbit-dot" />
        </div>
        <p className="cow-loader-text">{text}</p>
      </div>

      <style jsx>{`
        .cow-loader-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 60vh;
          background: var(--bg-primary);
        }

        .cow-loader-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.5rem;
        }

        .cow-orbit {
          position: relative;
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .cow-face {
          font-size: 3.2rem;
          animation: cow-bounce 1.2s ease-in-out infinite;
          z-index: 2;
          position: relative;
          filter: drop-shadow(0 4px 12px rgba(76,175,80,0.3));
        }

        .orbit-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 3px solid transparent;
          border-top-color: var(--accent-color);
          border-right-color: var(--accent-color);
          animation: orbit-spin 1s linear infinite;
        }

        .orbit-dot {
          position: absolute;
          width: 10px;
          height: 10px;
          background: var(--accent-color);
          border-radius: 50%;
          top: 4px;
          left: 50%;
          transform: translateX(-50%);
          animation: orbit-spin 1s linear infinite;
          box-shadow: 0 0 6px var(--accent-color);
        }

        .cow-loader-text {
          color: var(--text-muted);
          font-size: 0.95rem;
          margin: 0;
          letter-spacing: 0.03em;
          animation: fade-pulse 1.2s ease-in-out infinite;
        }

        @keyframes cow-bounce {
          0%, 100% { transform: translateY(0) scale(1); }
          50%       { transform: translateY(-6px) scale(1.08); }
        }

        @keyframes orbit-spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }

        @keyframes fade-pulse {
          0%, 100% { opacity: 0.5; }
          50%       { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
